import { ReviewEntriesFilterType } from '../enums/reviewEntriesFilterType'
import type {
  ReviewEntriesAmountRangeFilter,
  ReviewEntriesFiltersState,
  ReviewEntriesFilterValue,
} from '../types/reviewEntriesFilters'

export const isAmountRangeFilterEmpty = (range?: ReviewEntriesAmountRangeFilter): boolean =>
  range == null || (range.from === undefined && range.to === undefined)

export const isReviewEntriesFilterValueEmpty = <T extends ReviewEntriesFilterType>(
  type: T,
  value: ReviewEntriesFilterValue<T> | undefined,
): boolean => {
  if (value === undefined) {
    return true
  }

  if (type === ReviewEntriesFilterType.ExclVat || type === ReviewEntriesFilterType.InclVat) {
    return isAmountRangeFilterEmpty(value as ReviewEntriesAmountRangeFilter)
  }

  return (value as string[]).length === 0
}

export const getActiveReviewEntriesFilterTypes = (filters: ReviewEntriesFiltersState): ReviewEntriesFilterType[] =>
  Object.values(ReviewEntriesFilterType).filter(
    (type) => !isReviewEntriesFilterValueEmpty(type, filters[type]),
  ) as ReviewEntriesFilterType[]
